import React from "react";
import Footer from "../footer/footer";
import Header from "../Header/Header";
import { connect } from "react-redux";

const Error = (props) => {
  // console.log(props, "error");
  let styles = {
    colorwhite: "#FFF",
    colorblack: "#000",
  };
  return (
    <div className="error_page">
      {/* <Header /> */}
      {props.error == "true" ? (
        <>
          <div className="inner_body">
            <h2
              className="text-center"
              style={{
                color: "black",
              }}
            >
              404 not found
            </h2>
          </div>
        </>
      ) : null}

      <Footer />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    mode: state.mode.themeMode,
  };
};

export default connect(mapStateToProps, {})(Error);
